import React from "react";

const ActiveBusinessHourIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#2563EB"
        fillOpacity="0.1"
      />
      <path
        d="M32 19H16C14.8954 19 14 19.8954 14 21V31C14 32.1046 14.8954 33 16 33H32C33.1046 33 34 32.1046 34 31V21C34 19.8954 33.1046 19 32 19Z"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 33V17C28 16.4696 27.7893 15.9609 27.4142 15.5858C27.0391 15.2107 26.5304 15 26 15H22C21.4696 15 20.9609 15.2107 20.5858 15.5858C20.2107 15.9609 20 16.4696 20 17V33"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ActiveBusinessHourIcon;
